import React from "react";

import { IgTypography } from "@intelligems/ig-theme";

export interface LabelProps {
  children?: React.ReactNode;
}

export const Label = ({ children }: LabelProps) => {
  return <IgTypography fontWeight={400}>{children}</IgTypography>;
};
